import { z } from "zod";
export const guidelineContainerSchema = z.enum(["ESTIMATE", "COMMISSIONED_EXPERT_REPORT", "REPAIR_SERVICE"]);
export const incidentGuidelinesSchema = z.object({
    ESTIMATE: z.string(),
    COMMISSIONED_EXPERT_REPORT: z.string(),
    REPAIR_SERVICE: z.string(),
});
